import type {ReactNode} from 'react';
import {Tag} from 'lucide-react';
import {useTranslation} from 'react-i18next';
import {HaloIcon} from '../halo-icon';
import {cn} from '../lib/cn';

export type EmptySectionPlaceholderProps = {
  title?: string;
  subtitle?: string;
  icon?: ReactNode;
  className?: string;
};

export function EmptySectionPlaceholder({
  title,
  subtitle,
  icon,
  className,
}: EmptySectionPlaceholderProps) {
  const {t} = useTranslation();

  return (
    <div
      className={cn('flex flex-col items-center justify-center gap-6 py-6', className)}
    >
      <HaloIcon status="ACTIVE" className="h-20 w-20 [&>svg]:h-10 [&>svg]:w-10">
        {icon || <Tag size={40} />}
      </HaloIcon>
      <div className="flex flex-col items-center gap-2">
        <div className="font-medium leading-6">{title || t('nothing_found')}</div>
        {subtitle && (
          <div className="text-sm leading-6 text-[var(--chekin-color-gray-1)]">
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
}
